import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "lib/core/components/text/Text"
import PropTypes from "prop-types"
import React from "react"
import SubmissionFileUpload from "./SubmissionFileUpload"

class SubmissionFile extends React.Component {
  static displayName = "SubmissionFile"

  static contextTypes = {
    user: PropTypes.object
  }

  onFileSubmitted = (fpfile) => {
    return this.props.onFileSubmitted(fpfile)
  }

  render() {
    const {
      submission_instructions,
      submission_file_type,
      completion,
      onFileCleared
    } = this.props

    const { submission_file_url, submission_file_image, submission_file_name } =
      completion

    const { user } = this.context

    return (
      <div className="SubmissionFile">
        <Text html={submission_instructions} theme={true} katex={true} />
        <div className="Submission__box SubmissionArea">
          {(() => {
            if (completion.progress < 1 && submission_file_url) {
              return <h3>File uploaded but not submitted:</h3>
            } else if (completion.progress < 1) {
              return <h3>No file submitted:</h3>
            } else if (completion.progress === 1) {
              return <h3>You submitted:</h3>
            }
          })()}
          {submission_file_url ? (
            <div>
              <div className="UserFileSubmittedCard">
                {submission_file_image ? (
                  <img
                    src={
                      submission_file_image.thumb_square ||
                      submission_file_image.thumb
                    }
                  />
                ) : undefined}
                <a
                  href={submission_file_url}
                  target="_blank"
                  className="SubmissionFile__file-link"
                >
                  {submission_file_name}
                </a>
                {
                  // can only clear file if not submitted
                  completion.progress < 1 ? (
                    <a
                      href="javascript:"
                      onClick={onFileCleared}
                      className="SubmissionFile__clear"
                    >
                      <Pathicon icon="x" />
                      {` Clear\
`}
                    </a>
                  ) : undefined
                }
              </div>
            </div>
          ) : undefined}
          {!submission_file_url ? (
            <SubmissionFileUpload
              submission_file_type={submission_file_type}
              completion={completion}
              onFileSubmitted={this.onFileSubmitted}
            />
          ) : undefined}
        </div>
      </div>
    )
  }
}

export default SubmissionFile
